module.exports = __webpack_public_path__ + "img/desktop-menu-reference.3a8cd031.jpg";